import { Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import FigmaButtonArrow from './FigmaButtonArrow'
import ButtonText from './ButtonText'
import { buttonHoverPrimarySx } from '../../theme/buttonHover'
import { buttonWithArrowSx, responsiveButtonSx } from '../../theme/mobileLayout'

const withoutArrowLayoutSx = {
  justifyContent: 'center',
  alignItems: 'center',
}

export default function PrimaryButton({
  children,
  to,
  onClick,
  showArrow = true,
  sx = {},
  fullWidth: _fullWidth,
  ...props
}) {
  const buttonProps = to ? { component: RouterLink, to } : { onClick }

  return (
    <Button
      variant="contained"
      disableElevation
      sx={{
        display: 'inline-flex',
        textTransform: 'none',
        fontWeight: 400,
        ...responsiveButtonSx,
        ...(showArrow ? buttonWithArrowSx : withoutArrowLayoutSx),
        ...buttonHoverPrimarySx,
        ...sx,
      }}
      {...buttonProps}
      {...props}
    >
      <ButtonText>{children}</ButtonText>
      {showArrow && <FigmaButtonArrow />}
    </Button>
  )
}
